export default __webpack_public_path__ + "static/media/fox_audit.a0ad5655.png";